<template>
  <div class="stock-favorite">
    <div class="page-header">
      <div class="page-title">
        <div class="title-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h1>自选股票</h1>
        <div class="title-decoration"></div>
      </div>
      <p class="page-subtitle">管理您的自选股票，随时关注重点投资标的</p>
    </div>

    <div class="filter-bar">
      <el-input
        v-model="searchKeyword"
        placeholder="搜索股票代码、名称或备注"
        clearable
        class="search-input"
        @clear="handleSearch"
        @keyup.enter.native="handleSearch"
      >
        <i slot="prefix" class="el-icon-search input-icon"></i>
      </el-input>
      <el-button type="primary" @click="handleSearch">
        <i class="el-icon-search"></i>
        <span>搜索</span>
      </el-button>
      <el-button icon="el-icon-refresh" @click="fetchData" :loading="loading">
        <i class="el-icon-refresh"></i>
        <span>刷新</span>
      </el-button>
    </div>

    <div class="stock-count">共 <strong>{{ total }}</strong> 只自选股票</div>

    <el-table
      :data="stockList"
      v-loading="loading"
      border
      stripe
      style="width: 100%"
      class="stock-table"
    >
      <el-table-column prop="stock_code" label="股票代码" width="120">
      </el-table-column>
      <el-table-column prop="stock_name" label="股票名称" width="150">
      </el-table-column>
      <el-table-column prop="updated_at" label="更新时间" width="120">
        <template slot-scope="scope">
          {{ formatUpdatedDate(scope.row.updated_at) }}
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="500">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.remark"
            placeholder="请输入备注"
            size="small"
            clearable
            class="remark-input"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="420">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click.stop="viewKLine(scope.row, 'day')"
          >
            日K
          </el-button>
          <el-button
            type="text"
            size="small"
            @click.stop="viewKLine(scope.row, 'week')"
          >
            周K
          </el-button>
          <el-button
            type="text"
            size="small"
            @click.stop="viewKLine(scope.row, '5min')"
          >
            5分
          </el-button>
          <el-button
            type="text"
            size="small"
            :loading="scope.row.creatingMinuteTask"
            @click.stop="createMinuteTask(scope.row)"
            class="btn-minute"
          >
            分钟
          </el-button>
          <el-button
            type="text"
            size="small"
            :loading="scope.row.creatingTickTask"
            @click.stop="createTickTask(scope.row)"
            class="btn-tick"
          >
            tick
          </el-button>
          <el-button
            type="text"
            size="small"
            :loading="scope.row.saving"
            @click.stop="saveRemark(scope.row)"
            class="btn-save"
          >
            保存
          </el-button>
          <el-button
            type="text"
            size="small"
            :loading="scope.row.removing"
            @click.stop="removeFromFavorite(scope.row)"
            class="btn-delete"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      class="pagination"
    >
    </el-pagination>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'StockFavorite',
  data() {
    return {
      loading: false,
      stockList: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchKeyword: '',
      userId: '1'
    }
  },
  computed: {},
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const params = {
          user_id: this.userId,
          page: this.currentPage,
          page_size: this.pageSize
        }
        if (this.searchKeyword) {
          params.keyword = this.searchKeyword
        }

        const response = await axios.get('/stock/favorite/list', { params })
        console.log('自选股票接口返回:', response.data)

        if (response.data && response.data.data && Array.isArray(response.data.data)) {
          this.stockList = response.data.data
          this.total = response.data.total || 0
          console.log('自选股票数量:', this.stockList.length, '总数:', this.total)
        } else {
          this.stockList = []
          this.total = 0
          console.warn('返回数据格式不正确:', response.data)
        }
      } catch (error) {
        console.error('获取自选股票失败:', error)
        this.$message.error('获取自选股票失败')
        this.stockList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },

    viewKLine(row, type) {
      const routeMap = {
        'day': '/kline/day',
        'week': '/kline/week',
        '5min': '/kline/5min'
      }
      this.$router.push({
        path: routeMap[type],
        query: { code: row.stock_code }
      })
    },

    async saveRemark(row) {
      this.$set(row, 'saving', true)
      try {
        const response = await axios.put(`/stock/favorites/${this.userId}/${row.stock_code}/remark`, {
          remark: row.remark || ''
        })
        if (response.data) {
          this.$message.success('备注保存成功')
        } else {
          this.$message.error('保存失败')
        }
      } catch (error) {
        console.error('保存备注失败:', error)
        this.$message.error('保存备注失败: ' + (error.response?.data?.message || error.message))
      } finally {
        this.$set(row, 'saving', false)
      }
    },

    async removeFromFavorite(row) {
      this.$confirm(`确定要从自选中删除 ${row.stock_name} 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.$set(row, 'removing', true)
        try {
          const response = await axios.delete(`/stock/favorite/${this.userId}/${row.stock_code}`)
          if (response.data) {
            this.$message.success(`已将 ${row.stock_name} 从自选中删除`)
            this.fetchData()
          } else {
            this.$message.error('删除失败')
          }
        } catch (error) {
          console.error('删除自选失败:', error)
          this.$message.error('删除自选失败: ' + (error.response?.data?.message || error.message))
        } finally {
          this.$set(row, 'removing', false)
        }
      }).catch(() => {})
    },

    // 创建分钟级数据定时任务
    async createMinuteTask(row) {
      this.$set(row, 'creatingMinuteTask', true)
      try {
        const stockCode = row.stock_code
        const stockName = row.stock_name

        // 先检查是否已存在该股票的分钟数据任务
        const tasksRes = await axios.get('/scheduled-tasks/tasks')
        let existingTasks = []
        if (tasksRes.data?.status === 'success') {
          existingTasks = tasksRes.data.data.filter(t =>
            t.task_name.includes('分钟数据') && t.task_name.includes(stockCode)
          )
        }

        // 按时间段分类
        const morningTask = existingTasks.find(t => t.task_name.includes('上午'))
        const afternoonTask = existingTasks.find(t => t.task_name.includes('下午'))

        // 用于存储用户选择
        let userChoice = existingTasks.length === 0 ? 'on' : 'off'
        let createMorning = !existingTasks.some(t => t.task_name.includes('上午'))  // 默认创建上午任务
        let createAfternoon = !existingTasks.some(t => t.task_name.includes('下午'))  // 默认创建下午任务

        // 使用弹窗配置
        try {
          await this.$msgbox({
            title: '分钟数据定时任务',
            message: this.$createElement('div', { style: 'padding: 10px 0;' }, [
              this.$createElement('div', { style: 'margin-bottom: 15px;' }, [
                this.$createElement('label', { style: 'display: flex; align-items: center; cursor: pointer; color: #e2e8f0; font-size: 14px;' }, [
                  this.$createElement('input', {
                    attrs: { type: 'radio', name: 'minute-choice', value: 'on' },
                    domProps: { checked: existingTasks.length === 0 },
                    on: { change: () => { userChoice = 'on' } },
                    style: 'margin-right: 8px;'
                  }),
                  this.$createElement('span', '开启任务')
                ])
              ]),
              this.$createElement('div', { style: 'margin-bottom: 15px;' }, [
                this.$createElement('label', { style: 'display: flex; align-items: center; cursor: pointer; color: #e2e8f0; font-size: 14px;' }, [
                  this.$createElement('input', {
                    attrs: { type: 'radio', name: 'minute-choice', value: 'off' },
                    domProps: { checked: existingTasks.length > 0 },
                    on: { change: () => { userChoice = 'off' } },
                    style: 'margin-right: 8px;'
                  }),
                  this.$createElement('span', { style: 'color: #ef4444;' }, '关闭任务')
                ])
              ]),
              // 开启任务时显示的复选框
              existingTasks.length === 0 ? this.$createElement('div', { style: 'margin-bottom: 15px; padding: 12px; background: rgba(30, 41, 59, 0.5); border-radius: 6px; border: 1px solid rgba(99, 102, 241, 0.3);' }, [
                this.$createElement('div', { style: 'font-size: 13px; color: #e2e8f0; margin-bottom: 10px;' }, '选择要创建的任务：'),
                this.$createElement('label', { style: 'display: flex; align-items: center; cursor: pointer; margin-bottom: 8px; color: #cbd5e1;' }, [
                  this.$createElement('input', {
                    attrs: { type: 'checkbox', id: 'create-morning' },
                    domProps: { checked: true },
                    on: { change: (e) => { createMorning = e.target.checked } },
                    style: 'margin-right: 8px;'
                  }),
                  this.$createElement('span', { style: 'font-size: 12px;' }, '上午任务（收盘后执行）')
                ]),
                this.$createElement('label', { style: 'display: flex; align-items: center; cursor: pointer; color: #cbd5e1;' }, [
                  this.$createElement('input', {
                    attrs: { type: 'checkbox', id: 'create-afternoon' },
                    domProps: { checked: true },
                    on: { change: (e) => { createAfternoon = e.target.checked } },
                    style: 'margin-right: 8px;'
                  }),
                  this.$createElement('span', { style: 'font-size: 12px;' }, '下午任务（收盘后执行）')
                ])
              ]) : null,
              // 关闭任务时显示的复选框
              existingTasks.length > 0 ? this.$createElement('div', { style: 'margin-bottom: 15px; padding: 12px; background: rgba(30, 41, 59, 0.5); border-radius: 6px; border: 1px solid rgba(239, 68, 68, 0.3);' }, [
                this.$createElement('div', { style: 'font-size: 13px; color: #e2e8f0; margin-bottom: 10px;' }, '选择要删除的任务：'),
                morningTask ? this.$createElement('label', { style: 'display: flex; align-items: center; cursor: pointer; margin-bottom: 8px; color: #cbd5e1;' }, [
                  this.$createElement('input', {
                    attrs: { type: 'checkbox', id: 'delete-morning-min' },
                    domProps: { checked: true },
                    on: { change: (e) => { createMorning = !e.target.checked } },  // 反向逻辑：不删除=创建
                    style: 'margin-right: 8px;'
                  }),
                  this.$createElement('span', { style: 'font-size: 12px;' }, `上午任务 (${morningTask.task_name})`)
                ]) : null,
                afternoonTask ? this.$createElement('label', { style: 'display: flex; align-items: center; cursor: pointer; color: #cbd5e1;' }, [
                  this.$createElement('input', {
                    attrs: { type: 'checkbox', id: 'delete-afternoon-min' },
                    domProps: { checked: true },
                    on: { change: (e) => { createAfternoon = !e.target.checked } },
                    style: 'margin-right: 8px;'
                  }),
                  this.$createElement('span', { style: 'font-size: 12px;' }, `下午任务 (${afternoonTask.task_name})`)
                ]) : null
              ]) : null,
              this.$createElement('div', { style: 'font-size: 12px; color: #94a3b8;' }, '执行时间：收盘后（16:00）执行当日分钟数据获取')
            ]),
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            beforeClose: (action, _instance, done) => {
              if (action === 'confirm') {
                if (userChoice === 'on' && !createMorning && !createAfternoon) {
                  this.$message.warning('请至少选择一个要创建的任务')
                  return
                }
              }
              done()
            }
          })
        } catch {
          this.$set(row, 'creatingMinuteTask', false)
          return
        }

        // 用户选择关闭任务
        if (userChoice === 'off') {
          const toDelete = []
          if (!createMorning && morningTask) toDelete.push(morningTask)
          if (!createAfternoon && afternoonTask) toDelete.push(afternoonTask)

          if (toDelete.length > 0) {
            await Promise.all(toDelete.map(task =>
              axios.delete(`/scheduled-tasks/tasks/${task.id}`)
            ))
            this.$message.success(`已删除 ${toDelete.length} 个分钟数据任务`)
          } else {
            this.$message.info('没有选择要删除的任务')
          }
          this.$set(row, 'creatingMinuteTask', false)
          return
        }

        // 用户选择开启任务
        const tasksToCreate = []

        // 处理股票代码：去掉前缀（sz./sh.）
        const cleanStockCode = stockCode.includes('.') ? stockCode.split('.').pop() : stockCode

        // 先删除已存在的任务（如果有），避免重复
        if (existingTasks.length > 0) {
          await Promise.all(existingTasks.map(task =>
            axios.delete(`/scheduled-tasks/tasks/${task.id}`)
          ))
        }

        // 创建上午任务
        if (createMorning) {
          tasksToCreate.push({
            task_name: `分钟数据-上午-${stockCode}-${stockName}`,
            api_endpoint: '/stock/bill/today/fetch',
            http_method: 'POST',
            parameters: { stock_code: cleanStockCode },
            schedule_type: 'cron',
            schedule_config: {
              hour: '12',
              minute: '0',
              second: '0'
            },
            enabled: true
          })
        }

        // 创建下午任务
        if (createAfternoon) {
          tasksToCreate.push({
            task_name: `分钟数据-下午-${stockCode}-${stockName}`,
            api_endpoint: '/stock/bill/today/fetch',
            http_method: 'POST',
            parameters: { stock_code: cleanStockCode },
            schedule_type: 'cron',
            schedule_config: {
              hour: '16',
              minute: '0',
              second: '0'
            },
            enabled: true
          })
        }

        if (tasksToCreate.length > 0) {
          const results = await Promise.all(
            tasksToCreate.map(task => axios.post('/scheduled-tasks/tasks', task))
          )
          if (results.every(r => r.data?.status === 'success')) {
            const taskTypes = []
            if (createMorning) taskTypes.push('上午')
            if (createAfternoon) taskTypes.push('下午')
            this.$message.success(`已为 ${stockName} 创建${taskTypes.join('、')}分钟数据任务`)
          } else {
            this.$message.error('创建任务失败')
          }
        } else {
          this.$message.info('没有选择要创建的任务')
        }
      } catch (error) {
        console.error('操作分钟任务失败:', error)
        this.$message.error('操作失败: ' + (error.response?.data?.error || error.message))
      } finally {
        this.$set(row, 'creatingMinuteTask', false)
      }
    },

    // 创建tick数据定时任务（创建两个任务：上午和下午）
    async createTickTask(row) {
      this.$set(row, 'creatingTickTask', true)
      try {
        const stockCode = row.stock_code
        const stockName = row.stock_name

        // 先检查是否已存在该股票的tick监控任务
        const tasksRes = await axios.get('/scheduled-tasks/tasks')
        let existingTasks = []
        if (tasksRes.data?.status === 'success') {
          existingTasks = tasksRes.data.data.filter(t =>
            t.task_name.includes('tick监控') && t.task_name.includes(stockCode)
          )
        }

        // 按时间段分类
        const morningTask = existingTasks.find(t => t.task_name.includes('上午'))
        const afternoonTask = existingTasks.find(t => t.task_name.includes('下午'))

        // 用于存储用户选择
        let userChoice = existingTasks.length === 0 ? 'on' : 'off'
        let intervalSeconds = 10
        let createMorning = !morningTask  // 默认创建不存在的任务
        let createAfternoon = !afternoonTask  // 默认创建不存在的任务
        let deleteMorning = !!morningTask  // 默认选中已存在的任务
        let deleteAfternoon = !!afternoonTask  // 默认选中已存在的任务

        // 使用弹窗配置
        try {
          await this.$msgbox({
            title: 'Tick数据监控',
            message: this.$createElement('div', { style: 'padding: 10px 0;' }, [
              this.$createElement('div', { style: 'margin-bottom: 15px;' }, [
                this.$createElement('label', { style: 'display: flex; align-items: center; cursor: pointer; color: #e2e8f0; font-size: 14px;' }, [
                  this.$createElement('input', {
                    attrs: { type: 'radio', name: 'tick-choice', value: 'on' },
                    domProps: { checked: existingTasks.length === 0 },
                    on: { change: () => { userChoice = 'on' } },
                    style: 'margin-right: 8px;'
                  }),
                  this.$createElement('span', '开启监控')
                ])
              ]),
              this.$createElement('div', { style: 'margin-bottom: 15px;' }, [
                this.$createElement('label', { style: 'display: flex; align-items: center; cursor: pointer; color: #e2e8f0; font-size: 14px;' }, [
                  this.$createElement('input', {
                    attrs: { type: 'radio', name: 'tick-choice', value: 'off' },
                    domProps: { checked: existingTasks.length > 0 },
                    on: { change: () => { userChoice = 'off' } },
                    style: 'margin-right: 8px;'
                  }),
                  this.$createElement('span', { style: 'color: #ef4444;' }, '关闭监控')
                ])
              ]),
              // 开启任务时显示的复选框
              existingTasks.length === 0 ? this.$createElement('div', { style: 'margin-bottom: 15px; padding: 12px; background: rgba(30, 41, 59, 0.5); border-radius: 6px; border: 1px solid rgba(99, 102, 241, 0.3);' }, [
                this.$createElement('div', { style: 'font-size: 13px; color: #e2e8f0; margin-bottom: 10px;' }, '选择要创建的任务：'),
                this.$createElement('label', { style: 'display: flex; align-items: center; cursor: pointer; margin-bottom: 8px; color: #cbd5e1;' }, [
                  this.$createElement('input', {
                    attrs: { type: 'checkbox', id: 'create-morning-tick' },
                    domProps: { checked: true },
                    on: { change: (e) => { createMorning = e.target.checked } },
                    style: 'margin-right: 8px;'
                  }),
                  this.$createElement('span', { style: 'font-size: 12px;' }, '上午任务（9:30-11:30）')
                ]),
                this.$createElement('label', { style: 'display: flex; align-items: center; cursor: pointer; color: #cbd5e1;' }, [
                  this.$createElement('input', {
                    attrs: { type: 'checkbox', id: 'create-afternoon-tick' },
                    domProps: { checked: true },
                    on: { change: (e) => { createAfternoon = e.target.checked } },
                    style: 'margin-right: 8px;'
                  }),
                  this.$createElement('span', { style: 'font-size: 12px;' }, '下午任务（13:00-15:00）')
                ])
              ]) : null,
              // 关闭任务时显示的复选框
              existingTasks.length > 0 ? this.$createElement('div', { style: 'margin-bottom: 15px; padding: 12px; background: rgba(30, 41, 59, 0.5); border-radius: 6px; border: 1px solid rgba(239, 68, 68, 0.3);' }, [
                this.$createElement('div', { style: 'font-size: 13px; color: #e2e8f0; margin-bottom: 10px;' }, '选择要删除的任务：'),
                morningTask ? this.$createElement('label', { style: 'display: flex; align-items: center; cursor: pointer; margin-bottom: 8px; color: #cbd5e1;' }, [
                  this.$createElement('input', {
                    attrs: { type: 'checkbox', id: 'delete-morning' },
                    domProps: { checked: true },
                    on: { change: (e) => { deleteMorning = e.target.checked } },
                    style: 'margin-right: 8px;'
                  }),
                  this.$createElement('span', { style: 'font-size: 12px;' }, `上午任务 (${morningTask.task_name})`)
                ]) : null,
                afternoonTask ? this.$createElement('label', { style: 'display: flex; align-items: center; cursor: pointer; color: #cbd5e1;' }, [
                  this.$createElement('input', {
                    attrs: { type: 'checkbox', id: 'delete-afternoon' },
                    domProps: { checked: true },
                    on: { change: (e) => { deleteAfternoon = e.target.checked } },
                    style: 'margin-right: 8px;'
                  }),
                  this.$createElement('span', { style: 'font-size: 12px;' }, `下午任务 (${afternoonTask.task_name})`)
                ]) : null,
                !morningTask && !afternoonTask ? this.$createElement('div', { style: 'font-size: 12px; color: #94a3b8;' }, '暂无监控任务') : null
              ]) : null,
              this.$createElement('div', { style: 'margin-bottom: 15px;' }, [
                this.$createElement('label', { style: 'display: block; margin-bottom: 8px; color: #e2e8f0;' }, '执行间隔（秒）'),
                this.$createElement('input', {
                  attrs: { type: 'number', value: '10', min: '1' },
                  domProps: { value: '10' },
                  on: { input: (e) => { intervalSeconds = parseInt(e.target.value) || 10 } },
                  style: 'width: 100%; padding: 8px; border: 1px solid rgba(99, 102, 241, 0.3); border-radius: 4px; background: rgba(30, 41, 59, 0.8); color: #e2e8f0;'
                })
              ]),
              this.$createElement('div', { style: 'font-size: 12px; color: #94a3b8;' }, '监控时段：上午 9:30-11:30，下午 13:00-15:00')
            ]),
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            beforeClose: (action, _instance, done) => {
              if (action === 'confirm') {
                if (isNaN(intervalSeconds) || intervalSeconds < 1) {
                  this.$message.warning('请输入有效的秒数')
                  return
                }
                if (userChoice === 'on' && !createMorning && !createAfternoon) {
                  this.$message.warning('请至少选择一个要创建的任务')
                  return
                }
                if (userChoice === 'off' && !deleteMorning && !deleteAfternoon) {
                  this.$message.warning('请至少选择一个要删除的任务')
                  return
                }
              }
              done()
            }
          })
        } catch {
          this.$set(row, 'creatingTickTask', false)
          return
        }

        // 用户选择关闭监控
        if (userChoice === 'off') {
          const toDelete = []
          if (deleteMorning && morningTask) toDelete.push(morningTask)
          if (deleteAfternoon && afternoonTask) toDelete.push(afternoonTask)

          if (toDelete.length > 0) {
            await Promise.all(toDelete.map(task =>
              axios.delete(`/scheduled-tasks/tasks/${task.id}`)
            ))
            this.$message.success(`已删除 ${toDelete.length} 个监控任务`)
          } else {
            this.$message.info('没有选择要删除的任务')
          }
          this.$set(row, 'creatingTickTask', false)
          return
        }

        // 用户选择开启监控
        const seconds = intervalSeconds
        const tasksToCreate = []

        // 处理股票代码：去掉前缀（sz./sh.）用于API调用
        const cleanStockCode = stockCode.includes('.') ? stockCode.split('.').pop() : stockCode

        // 先删除已存在的任务（如果有），避免重复
        if (existingTasks.length > 0) {
          await Promise.all(existingTasks.map(task =>
            axios.delete(`/scheduled-tasks/tasks/${task.id}`)
          ))
        }

        // 创建上午任务
        if (createMorning) {
          tasksToCreate.push({
            task_name: `tick监控-上午-${stockCode}-${stockName}`,
            api_endpoint: '/quote/realtime',
            http_method: 'GET',
            parameters: { code: cleanStockCode },
            schedule_type: 'cron',
            schedule_config: {
              day_of_week: '1-5',
              hour: '9-11',
              minute: '*',
              second: `*/${seconds}`
            },
            enabled: true
          })
        }

        // 创建下午任务
        if (createAfternoon) {
          tasksToCreate.push({
            task_name: `tick监控-下午-${stockCode}-${stockName}`,
            api_endpoint: '/quote/realtime',
            http_method: 'GET',
            parameters: { code: cleanStockCode },
            schedule_type: 'cron',
            schedule_config: {
              day_of_week: '1-5',
              hour: '13-14',
              minute: '*',
              second: `*/${seconds}`
            },
            enabled: true
          })
        }

        if (tasksToCreate.length > 0) {
          const results = await Promise.all(
            tasksToCreate.map(task => axios.post('/scheduled-tasks/tasks', task))
          )
          if (results.every(r => r.data?.status === 'success')) {
            const taskTypes = []
            if (createMorning) taskTypes.push('上午')
            if (createAfternoon) taskTypes.push('下午')

            // 立即执行任务（如果在交易时间段内）
            const now = new Date()
            const hour = now.getHours()
            const executeResults = []

            // 检查并执行上午任务
          if (createMorning && hour >= 9 && hour < 12) {
              const morningId = results[0]?.data?.data?.id
              if (morningId) {
                try {
                  await axios.post(`/scheduled-tasks/tasks/${morningId}/execute`)
                  executeResults.push('上午')
                } catch (e) {
                  console.error('上午任务执行失败:', e)
                }
              }
            }

            // 检查并执行下午任务
          if (createAfternoon && hour >= 13 && hour < 15) {
              const afternoonIdx = createMorning ? 1 : 0
              const afternoonId = results[afternoonIdx]?.data?.data?.id
              if (afternoonId) {
                try {
                  await axios.post(`/scheduled-tasks/tasks/${afternoonId}/execute`)
                  executeResults.push('下午')
                } catch (e) {
                  console.error('下午任务执行失败:', e)
                }
              }
            }

            const msg = `已为 ${stockName} 开启tick监控（${taskTypes.join('、')}，每${seconds}秒执行）`
            const extraMsg = executeResults.length > 0 ? `，已立即执行${executeResults.join('、')}任务` : ''
            this.$message.success(msg + extraMsg)
          } else {
            this.$message.error('创建任务失败')
          }
        } else {
          this.$message.info('没有选择要创建的任务')
        }
      } catch (error) {
        console.error('操作tick任务失败:', error)
        this.$message.error('操作失败: ' + (error.response?.data?.error || error.message))
      } finally {
        this.$set(row, 'creatingTickTask', false)
      }
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1 // 重置到第一页
      this.fetchData()
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchData()
    },

    handleSearch() {
      this.currentPage = 1 // 搜索时重置到第一页
      this.fetchData()
    },

    // 格式化更新时间为东八区日期
    formatUpdatedDate(dateStr) {
      if (!dateStr) return '-'

      try {
        // 解析日期字符串（假设后端返回的是ISO格式或UTC时间）
        const date = new Date(dateStr)

        // 检查日期是否有效
        if (isNaN(date.getTime())) return '-'

        // 转换为东八区时间（UTC+8）
        const utcTime = date.getTime()
        const offset = 8 * 60 * 60 * 1000 // 东八区偏移8小时
        const beijingTime = new Date(utcTime + offset)

        // 格式化为 YYYY-MM-DD
        const year = beijingTime.getUTCFullYear()
        const month = String(beijingTime.getUTCMonth() + 1).padStart(2, '0')
        const day = String(beijingTime.getUTCDate()).padStart(2, '0')

        return `${year}-${month}-${day}`
      } catch (error) {
        console.error('日期格式化失败:', error)
        return '-'
      }
    }
  }
}
</script>

<style scoped>
.stock-favorite {
  padding: 20px;
  min-height: calc(100vh - 104px);
  position: relative;
}

.page-header {
  text-align: center;
  margin-bottom: 32px;
  position: relative;
  z-index: 1;
}

.page-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 8px;
}

.title-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, rgba(251, 191, 36, 0.2) 0%, rgba(245, 158, 11, 0.2) 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fbbf24;
  border: 1px solid rgba(251, 191, 36, 0.3);
  box-shadow: 0 0 20px rgba(251, 191, 36, 0.15);
}

.title-icon svg {
  width: 24px;
  height: 24px;
}

.page-title h1 {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 50%, #fbbf24 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 1px;
}

.title-decoration {
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, transparent 0%, #f59e0b 50%, transparent 100%);
  border-radius: 2px;
}

.page-subtitle {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  letter-spacing: 0.5px;
}

.filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3),
              inset 0 1px 0 rgba(255, 255, 255, 0.05);
  position: relative;
  z-index: 1;
}

.search-input {
  width: 300px;
}

.search-input :deep(.el-input__inner) {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(99, 102, 241, 0.2);
  color: #e2e8f0;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.search-input :deep(.el-input__inner):hover {
  border-color: rgba(99, 102, 241, 0.4);
}

.search-input :deep(.el-input__inner):focus {
  border-color: #6366f1;
  box-shadow: 0 0 16px rgba(99, 102, 241, 0.25);
}

.search-input :deep(.input-icon) {
  color: rgba(99, 102, 241, 0.6);
}

.filter-bar :deep(.el-button--primary) {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-weight: 500;
  box-shadow: 0 4px 16px rgba(99, 102, 241, 0.3);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.filter-bar :deep(.el-button--primary):hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(99, 102, 241, 0.45);
}

.filter-bar :deep(.el-button--primary i) {
  font-size: 16px;
}

.filter-bar :deep(.el-button--default) {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(99, 102, 241, 0.2);
  color: #e2e8f0;
  border-radius: 8px;
  padding: 10px 24px;
  font-weight: 500;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.filter-bar :deep(.el-button--default):hover {
  border-color: rgba(99, 102, 241, 0.4);
  background: rgba(99, 102, 241, 0.1);
}

.stock-count {
  margin-bottom: 16px;
  color: #94a3b8;
  font-size: 14px;
  padding: 10px 16px;
  background: rgba(251, 191, 36, 0.08);
  border-radius: 8px;
  border-left: 3px solid #f59e0b;
  display: inline-block;
  position: relative;
  z-index: 1;
}

.stock-count strong {
  color: #fbbf24;
  font-weight: 600;
}

.stock-table {
  margin-bottom: 20px;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  z-index: 1;
  border: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(15, 23, 42, 0.3);
}

.stock-table :deep(.el-table__header-wrapper) {
  background: rgba(15, 23, 42, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px 12px 0 0;
}

.stock-table :deep(.el-table__header th) {
  background: rgba(30, 41, 59, 0.8) !important;
  color: #cbd5e1;
  font-weight: 600;
  border-bottom: 1px solid rgba(251, 191, 36, 0.2);
  padding: 14px 0;
}

.stock-table :deep(.el-table__body) {
  background: rgba(15, 23, 42, 0.5);
}

.stock-table :deep(.el-table__body tr) {
  background: rgba(30, 41, 59, 0.4) !important;
  transition: all 0.25s ease;
}

.stock-table :deep(.el-table__body tr.el-table__row--striped) {
  background: rgba(30, 41, 59, 0.25) !important;
}

.stock-table :deep(.el-table__body tbody tr:hover > td) {
  background: rgba(251, 191, 36, 0.08) !important;
}

.stock-table :deep(.el-table__body td) {
  background: transparent !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  color: #e2e8f0;
  padding: 12px 0;
}

.stock-table :deep(.el-table__body-wrapper) {
  background: rgba(15, 23, 42, 0.3);
  border-radius: 0 0 16px 16px;
}

.stock-table :deep(.el-button--text) {
  color: #a5b4fc;
  transition: all 0.2s ease;
}

.stock-table :deep(.el-button--text:hover) {
  color: #c7d2fe;
  text-shadow: 0 0 8px rgba(165, 180, 252, 0.4);
}

.stock-table :deep(.btn-save) {
  color: #22c55e;
}

.stock-table :deep(.btn-save:hover) {
  color: #4ade80;
  text-shadow: 0 0 8px rgba(34, 197, 94, 0.4);
}

.stock-table :deep(.btn-delete) {
  color: #ef4444;
}

.stock-table :deep(.btn-delete:hover) {
  color: #f87171;
  text-shadow: 0 0 8px rgba(239, 68, 68, 0.4);
}

.stock-table :deep(.btn-minute) {
  color: #06b6d4;
}

.stock-table :deep(.btn-minute:hover) {
  color: #22d3ee;
  text-shadow: 0 0 8px rgba(6, 182, 212, 0.4);
}

.stock-table :deep(.btn-tick) {
  color: #8b5cf6;
}

.stock-table :deep(.btn-tick:hover) {
  color: #a78bfa;
  text-shadow: 0 0 8px rgba(139, 92, 246, 0.4);
}

.stock-table :deep(.remark-input .el-input__inner) {
  background: rgba(15, 23, 42, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #e2e8f0;
  border-radius: 6px;
}

.stock-table :deep(.remark-input .el-input__inner):focus {
  border-color: #f59e0b;
  box-shadow: 0 0 12px rgba(251, 191, 36, 0.15);
}

.stock-table :deep(.remark-input .el-input__inner)::placeholder {
  color: rgba(226, 232, 240, 0.3);
}

.pagination {
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 1;
}

.pagination :deep(.el-pagination) {
  color: #94a3b8;
}

.pagination :deep(.el-pagination .el-pager li) {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  margin: 0 4px;
  min-width: 32px;
  height: 32px;
  line-height: 30px;
  transition: all 0.25s ease;
}

.pagination :deep(.el-pagination .el-pager li:hover) {
  border-color: rgba(251, 191, 36, 0.4);
  color: #fbbf24;
}

.pagination :deep(.el-pagination .el-pager li.active) {
  background: linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%);
  border-color: transparent;
  color: #ffffff;
  font-weight: 600;
}

.pagination :deep(.el-pagination button) {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  color: #94a3b8;
  transition: all 0.25s ease;
}

.pagination :deep(.el-pagination button:hover) {
  border-color: rgba(251, 191, 36, 0.4);
  color: #fbbf24;
}

.pagination :deep(.el-pagination .el-pagination__sizes .el-select .el-input .el-input__inner) {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #e2e8f0;
  border-radius: 6px;
}

.pagination :deep(.el-pagination .el-pagination__jump) {
  color: #94a3b8;
}
</style>
